<script setup lang="ts">
import type { ProductsList } from "~/models/Content/ContentProducts"

const { dark = true, ...props } = defineProps<{
  product?: ProductsList
  dark?: boolean
  backButton?: boolean
}>()

const variantStore = useProductVariantsStore()

const route = useRoute<"product">()
const title = computed(
  () =>
    props.product?.productTitleHtml ||
    props.product?.productTitle ||
    variantStore.activeProduct?.productTitle ||
    "",
)

const hasAtLeastOneReleasedProduct = computed(
  () => variantStore.activeProduct?.hasAtLeastOneReleasedProduct,
)

const loginPageUrl = useLoginPageUrl()

const showLoginButton = computed(() => {
  return (
    loginPageUrl.value &&
    !route.path.includes("betaling") &&
    !route.path.includes("logg-inn")
  )
})

const { isAuthorized, logout } = useAuth()

const isSmallScreen = useMediaQuery("(max-width: 744px)")
</script>

<template>
  <header
    class="flex size-full items-center justify-center overflow-hidden"
  >
    <div
      class="flex size-full max-w-[100em] items-center justify-between pb-4 pt-6 lg:py-10"
    >
      <div class="flex gap-4">
        <UButton
          v-if="backButton"
          variant="quite"
          to="/"
        >
          <UIcon
            name="arrow-left"
            size="md"
            class="pl-4 hover:text-[--u-contrast]"
          />
        </UButton>
        <ULogo :product="product" :dark="dark" />
      </div>
      <UButton
        v-if="
          title && hasAtLeastOneReleasedProduct && showLoginButton
        "
        :to="!isAuthorized ? loginPageUrl : undefined"
        :size="isSmallScreen ? 'sm' : 'lg'"
        variant="quite"
        @click="
          () => (isAuthorized ? logout(route.params.product) : null)
        "
      >
        {{ !isAuthorized ? "Logg inn" : "Logg ut" }}
      </UButton>
      <UButton
        v-else-if="!showLoginButton && isAuthorized"
        :size="isSmallScreen ? 'sm' : 'lg'"
        variant="quite"
        @click="logout(route.params.product)"
      >
        Logg ut
      </UButton>
    </div>
  </header>
</template>
